import React from 'react';
import './PhotoUploadOptions.css';

interface PhotoUploadOptionsProps {
  isOpen: boolean;
  onSelectFile: () => void;
  onSelectCamera: () => void;
  onClose: () => void;
  language: string;
}

export default function PhotoUploadOptions({
  isOpen,
  onSelectFile,
  onSelectCamera,
  onClose,
  language
}: PhotoUploadOptionsProps): React.ReactElement | null {
  const texts = {
    ko: {
      title: '사진 업로드 방식 선택',
      camera: '카메라로 촬영',
      cameraDesc: '지금 바로 사진을 촬영합니다',
      file: '갤러리에서 선택',
      fileDesc: '저장된 사진을 불러옵니다',
      cancel: '취소'
    },
    en: {
      title: 'Select Photo Upload Method',
      camera: 'Take Photo',
      cameraDesc: 'Capture a new photo now',
      file: 'Choose from Gallery',
      fileDesc: 'Select an existing photo',
      cancel: 'Cancel'
    }
  };

  const t = texts[language as keyof typeof texts] || texts.en;

  // Don't render if not open
  if (!isOpen) return null;

  return (
    <div className="photo-upload-overlay" onClick={onClose}>
      <div className="photo-upload-options" onClick={(e) => e.stopPropagation()}>
        <h3>{t.title}</h3>
        
        <button className="upload-option" onClick={onSelectCamera}>
          <span className="option-icon">📷</span>
          <div className="option-text">
            <strong>{t.camera}</strong>
            <small>{t.cameraDesc}</small>
          </div>
        </button>

        <button className="upload-option" onClick={onSelectFile}>
          <span className="option-icon">🖼️</span>
          <div className="option-text">
            <strong>{t.file}</strong>
            <small>{t.fileDesc}</small>
          </div>
        </button>

        <button className="cancel-option" onClick={onClose}>
          {t.cancel}
        </button>
      </div>
    </div>
  );
}
